import RedirectWithError from './RedirectWithError';

export default RedirectWithError;
